export default "__VITE_ASSET__d85cec40__"